<template>
  <!-- <loading
    :active="isLoading_Summary || isLoading"
    :is-full-page="fullPage"
    color="#007BFF"
  /> -->
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-lg-3 col-md-6 col-12">
            <router-link
              :to="{
                name: 'dashboard/member',
                query: { Status: 'All' },
              }"
            >
              <card
                title="Total Users"
                :value="summary.total_users"
                :isLoading="isLoading"
              ></card>
            </router-link>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <router-link
              :to="{
                name: 'dashboard/member',
                query: { Status: 'Active' },
              }"
            >
              <card
                title="Active"
                :value="summary.active_users"
                :isLoading="isLoading"
              ></card>
            </router-link>
          </div>
          <div class="col-lg-3 col-md-6 col-12">
            <router-link :to="{
                name: 'dashboard/member',
                query: { Status: 'Non Active' },
              }" class="pointer">
              <card
                title="Non Active"
                :value="summary.expired_users"
                :isLoading="isLoading"
              ></card>
            </router-link>
          </div>
        </div>
        <!-- <div class="d-none row">
          <div class="col-lg-12 mb-lg">
            <div class="card z-index-2">
              <gradient-line-chart />
            </div>
          </div>
        </div> -->
        <div class="mt-4">
          <users-table :title="'Users table '+(search_criteria.Status ? ' - ' +  search_criteria.Status : '')" :params="{search_criteria}" :rows="rows" :columns="columns" :isLoading="isLoading" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// const axios = require("axios");
/* eslint-disable */
import Card from "@/examples/Cards/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import Carousel from "./components/Carousel.vue";
import CategoriesCard from "./components/CategoriesCard.vue";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
import moment from "moment";

// import US from "@/assets/img/icons/flags/US.png";
// import DE from "@/assets/img/icons/flags/DE.png";
// import GB from "@/assets/img/icons/flags/GB.png";
// import BR from "@/assets/img/icons/flags/BR.png";

import UsersTable from "./components/usersTable.vue";

export default {
  name: "dashboard-default",
  data() {
    return {
      columns: [
        // {
        //   label: "USERNAME",
        //   field: "username",
        // },
        {
          label: "LINE DISPLAY/UID",
          field: "line_display",
        },
        {
          label: "Ref. Line Display/UID",
          field: "ref_line_display",
        },
        {
          label: "EXPIRE DATE",
          field: "expire_date",
          type: "date",
          //input ex: 2022-09-08T10:26:39.000Z
          dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXX",
          dateOutputFormat: "dd/MM/yyyy",
        },
        {
          label: "REMAINING DAY",
          field: "remaining_day",
          type: "number",
        },
      ],
      search_criteria: {
        // Status:'Active'
        Status: "All",
      },
    };
  },
  components: {
    UsersTable,
    Card,
    GradientLineChart,
    Carousel,
    CategoriesCard,
    // Loading,
  },
  methods: {
    getSummary() {
      this.$store.dispatch("getSummary");
    },
    countReferrees(row) {
      return this.rows_dicts[row.username] || 0;
    },
    getUsers() {
      //   this.$store.dispatch("getUsers");
    },
    filter_by_status(status) {
      console.log("filter_by_status", status);
      this.search_criteria.Status = status;
    },
  },
  computed: {
    summary() {
      return this.$store.state.summary;
    },
    isLoading_Summary() {
      return this.$store.state.isLoading_Summary;
    },
    rows() {
      return this.$store.state.users.filter((row) => {
        if (this.search_criteria.Status == "Active") {
            // return row.usage_days != 0;
            return moment(row.expire_date).isAfter(moment());
        //   return row.expire_date > new Date();
        } else if (this.search_criteria.Status == "Non Active") {
            return moment(row.expire_date).isBefore(moment());
            // return row.usage_days == 0;
        //   return row.expire_date < new Date();
        } else {
          return true;
        }
      });
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
  },
  created() {
    var user = window.localStorage.getItem("$logged_user");
    if (user != "admin") {
      this.$router.push("/");
      return;
    }
    const query = this.$route.query;

    this.getUsers();
    this.getSummary();
    if (query.Status) {
      this.filter_by_status(query.Status);
    }
  },
  watch: {
    // watch: {
    $route(to, from) {
      console.log("watch", {to,from, query:to.query});
        if (to.query.Status) {
            this.filter_by_status(to.query.Status);
        }
    },
  },
};
</script>
